import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col, Card } from "react-bootstrap";
import DonutView from "./DonutView";
import GraphView from "./GraphView";
import Summary from "./Summary";
import { PLAN_TYPE_COLOURS, GROUP_DASHBOARD_ANALYZE_KPI } from "../../../constants/index";
import { getCrewDonut, getCrewGraph, getCrewSummary, subscribeAnalyzeKPI, unsubscribeAnalyzeKPI } from "../../../actions/dashboard";
import { isToday } from "../../../helpers/common";
import { getDateRangeInfo } from "../../../actions/analyze";

const CrewCard = (props) => {
  const { item } = props;
  const dispatch = useDispatch();
  const planTypeListById = useSelector((state) => {
    const result = {};
    state.dashboard.planTypeList.payload.forEach((item) => {
      result[item.plan_type_id] = item;
    });
    return result;
  });

  const farmId = useSelector((state) => state.dashboard.farmId);
  const crewInfo = useSelector((state) => {
    const crewId = item.crew_uuid;
    return state.dashboard.crew.analyseById.hasOwnProperty(crewId) ? state.dashboard.crew.analyseById[crewId] : {};
  });
  const { range } = useSelector((state) => state.analyze.searchParams);
  const selectedPlanType = useSelector((state) => state.plan.selectedPlanType);
  const isAllPlan = useSelector((state) => state.plan.isSelectAllPlan);
  const selectedPlanTypeIds = useSelector((state) => state.dashboard.crew.selectedPlanTypeIds);
  const [crewViewType, setCrewViewType] = useState("summary");

  useEffect(() => {
    const dateInfo = dispatch(getDateRangeInfo());
    const params = {
      farmId: farmId,
      crewId: item.crew_uuid,
      range: dateInfo.range,
      fromDate: dateInfo.fromDate,
      toDate: dateInfo.toDate,
    };
    const selectedPlanForCrew = isAllPlan ? selectedPlanTypeIds[0] : selectedPlanType;

    if (!crewInfo.summary || isToday(range)) dispatch(getCrewSummary({ ...params, plan_type_id: selectedPlanForCrew }));

    const subscribeId = `${GROUP_DASHBOARD_ANALYZE_KPI}_${item.crew_uuid}`;
    dispatch(subscribeAnalyzeKPI({ ...params, subscribeId, view: "crew" }));

    return () => dispatch(unsubscribeAnalyzeKPI({ subscribeId }));
  }, []);

  useEffect(() => {
    const dateInfo = dispatch(getDateRangeInfo());
    const params = {
      farmId: farmId,
      crewId: item.crew_uuid,
      range: dateInfo.range,
      fromDate: dateInfo.fromDate,
      toDate: dateInfo.toDate,
    };

    if (crewViewType === "summary" && (!crewInfo.donut || isToday(range))) dispatch(getCrewDonut(params));
    if (crewViewType === "graph" && (!crewInfo.graph || isToday(range))) dispatch(getCrewGraph(params));
  }, [crewViewType]);

  const renderPlanType = () => {
    const planType = planTypeListById && planTypeListById[item.plan_type_id] && planTypeListById[item.plan_type_id].plan_type.split(" ")[0];
    const color = PLAN_TYPE_COLOURS[item.plan_type_id];
    return planType ? (
      <div className="type" style={{ color, borderColor: color }}>
        {planType}
      </div>
    ) : null;
  };

  return (
    <Card className="crew-item fadeInUp">
      <Card.Header className="crew-item-header">
        <Row className="crew-title">
          <Col className="name d-flex" lg={8} md={8} sm={8} title={item.crew_name}>
            {item.is_end_crew && <i className="fa fa-ban icon-end" aria-hidden="true"></i>}
            <div className={item.is_end_crew ? "text-end" : ""}>{item.crew_name}</div>
          </Col>
          <Col>{renderPlanType()}</Col>
        </Row>
      </Card.Header>
      <Card.Body className="crew-item-body">
        <Row className="body-header">
          {["summary", "graph"].map((type) => (
            <div key={type} className={`title ${crewViewType === type ? "active" : ""}`} onClick={() => setCrewViewType(type)} title={type.charAt(0).toUpperCase() + type.slice(1)}>
              {type.charAt(0).toUpperCase() + type.slice(1)}
            </div>
          ))}
        </Row>
        {crewViewType === "summary" ? <DonutView crewId={item.crew_uuid} /> : <GraphView crewId={item.crew_uuid} />}
      </Card.Body>
      <Card.Footer className="crew-item-footer">
        <Summary crewId={item.crew_uuid} />
      </Card.Footer>
    </Card>
  );
};

export default CrewCard;
